import React from 'react';
import { Empty, Icon } from 'antd';
import cn from 'classnames';
import styles from './InDeveloping.module.scss';

const InDeveloping = ({ className }) => {
  return (
    <div className={cn(styles.root, className)}>
      <Empty
        imageStyle={{ height: '80px' }}
        image={
          <Icon type="tool" theme="twoTone" style={{ fontSize: '80px' }} />
        }
        description="Модуль в разработке"
      />
    </div>
  );
};

export default InDeveloping;
